export interface TimezoneOption {
  value: string;
  label: string;
  offset: string;
}

export const getTimezones = (): TimezoneOption[] => {
  const IntlAny = Intl as any;
  const timezones: string[] = IntlAny.supportedValuesOf('timeZone');

  return timezones
    .map((tz: string) => {
      const date = new Date();
      let offset = '';

      try {
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: tz,
          timeZoneName: 'shortOffset'
        });

        const parts = formatter.formatToParts(date);
        const offsetPart = parts.find(part => part.type === 'timeZoneName');
        offset = offsetPart?.value || '';
      } catch (error) {
        offset = '';
      }

      const formattedLabel = tz.replace(/_/g, ' ');

      return {
        value: tz,
        label: `${formattedLabel} ${offset ? '(' + offset + ')' : ''}`,
        offset
      };
    })
    .sort((a: TimezoneOption, b: TimezoneOption) => a.label.localeCompare(b.label));
};
